import usePaginationHook from "../../hooks/usePaginationHook";
import { Pagination } from "@mantine/core";
import React, { useEffect } from "react";

function PaginationCard({ pagination, count }) {
  useEffect(() => {
    if (count) {
      pagination.setTotalItems(count);
    }
  }, [count]);
  return (
    <div className="mt-3 flex flex-wrap items-center  justify-between">
      <div>{count} items</div>
      <Pagination
        total={pagination.totalPages}
        onChange={pagination.setPage}
        // page={pagination.active}
        // styles={{
        //   item: {
        //     "&[data-active]": {
        //       background: "#404040",
        //     },
        //   },
        // }}
      />
    </div>
  );
}

export default PaginationCard;
